module.exports = __webpack_public_path__ + "assets/images/vector-fluxo-healthid-lab-moto.02c785d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vector-fluxo-healthid-lab-moto.png
// module id = 389
// module chunks = 1